export default __webpack_public_path__ + "static/media/limit-values.cc68bb0c.svg";